import { connect } from "react-redux";
import useApi from '../hooks/useApi';

// Required - No Library without this wrapper / hook
function ConnectedAPILinkWrapper({ auth }) {
  useApi(auth); // init Store API LINK Management
  return null;
}

const APILinkWrapper = connect(
  state => ({
    auth: state.auth, // Handle Sign In / Out
  })
)(ConnectedAPILinkWrapper);

export default APILinkWrapper;
